<template>
  <div class="jokyoShokai">
    <div>
      <el-row id="formArea">
        <el-col :span="7">
          <el-button type="default" @click="onChange(-1)" size="medium" icon="el-icon-arrow-left">前月</el-button>
          <el-date-picker v-model="form.nengetsu" type="month" @change="onChange" format="yyyy年 M月" value-format="yyyy-MM" :editable="false" :clearable="false" class="nengetsu" size="medium"></el-date-picker>
          <el-button type="default" @click="onChange(1)" size="medium">翌月 <i class="el-icon-arrow-right" /></el-button>
        </el-col>
        <el-col :span="17">
          <el-button v-if="canSelect" type="primary" @click="onDownload('ikkatsuDownload', 'Excel', 50)" size="medium">Excel一括出力</el-button>
          <el-button v-if="canShonin" type="success" @click="onShonin()" size="medium">上長承認</el-button>
          <el-button v-if="canKakutei" type="success" @click="onKakutei()" size="medium">労務確定</el-button>
          <el-button v-if="canKaijo" type="danger" @click="onKaijo()" size="medium">確定解除</el-button>
          <el-button v-if="canData" type="primary" @click="onDownload('kyuyoDataDownload', 'データ', 1000)" size="medium">データ出力</el-button>
          <el-button v-if="canHenshu" type="default" @click="showShainDialog(null)" size="medium">社員登録</el-button>
          <el-button v-if="canHenshu" type="default" @click="showKyujitsuDialog()" size="medium">休日登録</el-button>
        </el-col>
      </el-row>
    </div>
    <div id="selectButtons" :class="selectButtonsSizeClass">
      <span class="selecterLabel">選択可能行のみ表示：</span>
      <el-switch v-model="showOnlySelected">
      </el-switch>
      <span class="selecterLabel">在職者のみ表示：</span>
      <el-switch v-model="showOnlyWorker">
      </el-switch>
      <span class="selecterLabel">状況：</span>
      <el-radio-group v-model="jokyoSelect" size="mini" @change="changeSelect">
        <el-radio-button label="All">全て</el-radio-button>
        <el-radio-button label="21">上長承認待ち</el-radio-button>
        <el-radio-button label="51">労務受付待ち</el-radio-button>
        <el-radio-button label="52">労務確認中</el-radio-button>
        <el-radio-button label="53">労務確認済み</el-radio-button>
        <el-radio-button label="54">労務処理済み</el-radio-button>
      </el-radio-group>
      <span class="selecterLabel">Check結果：</span>
      <el-radio-group v-model="checkSelect" size="mini" @change="changeSelect">
        <el-radio-button label="All">全て</el-radio-button>
        <el-radio-button label="OK">OK</el-radio-button>
        <el-radio-button label="Warning">Warning</el-radio-button>
        <el-radio-button label="Error">Error</el-radio-button>
      </el-radio-group>
      <span v-if="isRomu" class="selecterLabel">社員：</span>
      <el-radio-group v-if="isRomu" v-model="shainSelect" size="mini" @change="changeSelect">
        <el-radio-button label="All">全て</el-radio-button>
        <el-radio-button label="S">正社員</el-radio-button>
        <el-radio-button label="O">正社員以外</el-radio-button>
      </el-radio-group>
    </div>
    <el-table id="jokyoShokaiTable" ref="jokyoShokaiTable" :class="tableSizeClass" :data="form.shainList.filter(data => (this.doFilter(data)))"
        :default-sort="{prop: 'shainBango', order: 'ascending'}" :height="tableHeight" @select="selectTable" v-loading="loading" stripe border>
      <el-table-column type="selection" :selectable="isSelectable" width="40"></el-table-column>
      <el-table-column type="index" label="No." width="50"></el-table-column>
      <el-table-column label="参照" width="57">
        <template slot-scope="scope">
          <el-button icon="el-icon-view" size="mini" @click="gyomuHokoku(scope.row)"></el-button>
        </template>
      </el-table-column>
      <el-table-column label="社員ID" width="210" sortable>
        <template slot-scope="scope">
          <div v-if="!(canHenshu || canSettei(scope.row))">{{scope.row.shainId}}</div>
          <el-link v-if="canHenshu || canSettei(scope.row)" @click="showShainDialog(scope.row)" type="success">{{scope.row.shainId}}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="shainBango" label="社員番号" width="85" sortable></el-table-column>
      <el-table-column prop="shainShimei" label="社員氏名" width="142" sortable></el-table-column>
      <el-table-column prop="jokyoKubunMei" label="状況" width="105" sortable></el-table-column>
      <el-table-column prop="checkKekka" label="Check結果" width="100" sortable></el-table-column>
      <el-table-column label="提出ｺﾒﾝﾄ" width="62">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.teishutsuComment != null" effect="light" placement="left">
            <div slot="content" class="comment-tooltip">{{scope.row.teishutsuComment}}</div>
            <el-link type="success">有</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="上長ｺﾒﾝﾄ" width="62">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.jochoComment != null" effect="light" placement="bottom">
            <div slot="content" class="comment-tooltip">{{scope.row.jochoComment}}</div>
            <el-link type="success">有</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="労務ｺﾒﾝﾄ" width="62">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.romuComment != null" effect="light" placement="right">
            <div slot="content" class="comment-tooltip">{{scope.row.romuComment}}</div>
            <el-link type="success">有</el-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="shukkinNissu" label="出勤" width="58" sortable></el-table-column>
      <el-table-column prop="kekkinNissu" label="欠勤" width="58" sortable></el-table-column>
      <el-table-column prop="yukyuNissu" label="有休" width="58" sortable></el-table-column>
      <el-table-column prop="yukyuJikansu" label="有時" width="58" sortable></el-table-column>
      <el-table-column prop="gokeiTsujoZangyo" label="残業" width="58" align="right"></el-table-column>
      <el-table-column prop="gokeiDoyoShukujitsuKimmu" label="土祝" width="58" align="right"></el-table-column>
      <el-table-column prop="gokeiNichiyoKimmu" label="日曜" width="58" align="right"></el-table-column>
      <el-table-column v-if="isRomu" prop="romuCheck1Flag" label="労務1" width="64" sortable></el-table-column>
      <el-table-column v-if="isRomu" prop="romuCheck2Flag" label="労務2" width="64" sortable></el-table-column>
      <el-table-column v-if="isRomu" prop="romuCheck3Flag" label="労務3" width="64" sortable></el-table-column>
    </el-table>
    <ShainToroku :shainDialogVisible.sync="shainDialogVisible" :shain.sync="shain" @close-shain-dialog="onCloseShainDialog" />
    <ShainTorokuJocho :shainJochoDialogVisible.sync="shainJochoDialogVisible" :shain.sync="shain" @close-shain-jocho-dialog="onCloseShainJochoDialog" />
    <KyujitsuToroku :kyujitsuDialogVisible.sync="kyujitsuDialogVisible" @close-kyujitsu-dialog="kyujitsuDialogVisible = false" />
  </div>
</template>

<script>
import { notifySuccess, notifyWarning, notifyError, downloadFile } from '../utils.js'
import ShainToroku from '../components/ShainToroku.vue'
import ShainTorokuJocho from '../components/ShainTorokuJocho.vue'
import KyujitsuToroku from '../components/KyujitsuToroku.vue'

export default {
  name: 'JokyoShokai',
  components: {
    ShainToroku,
    ShainTorokuJocho,
    KyujitsuToroku
  },
  data() {
    return {
      form: {
        nengetsu: '',
        shainList: [],
      },
      tableHeight: 0,
      targetRow: null,
      shain: null,
      shainDialogVisible: false,
      shainJochoDialogVisible: false,
      kyujitsuDialogVisible: false,
      shainIdDisabled: true,
      jokyoSelect: null,
      checkSelect: null,
      shainSelect: null,
      showOnlySelected: true,
      showOnlyWorker: true,
      loading: true
    }
  },
  computed: {
    canShonin() {
      return (this.form.shainList.length > 1);
    },
    canKakutei() {
      return (this.$parent.getKengenKubun() >= '700');
    },
    canKaijo() {
      return (this.$parent.getKengenKubun() >= '700');
    },
    canHenshu() {
      return (this.$parent.getKengenKubun() >= '700');
    },
    canSelect() {
      return (this.form.shainList.length > 1);
    },
    canData() {
      return (this.$parent.getKengenKubun() >= '700');
    },
    isRomu() {
      return (this.$parent.getKengenKubun() >= '700');
    },
    selectButtonsSizeClass() {
      return this.isRomu ? "selectButtonsSizeRomu" : "selectButtonsSize";
    },
    tableSizeClass() {
      return this.isRomu ? "jokyoShokaiTableSizeRomu" : "jokyoShokaiTableSize";
    },
  },
  created() {
    if (this.$route.params.nengetsu === undefined) {
      this.form.nengetsu = this.$parent.getNengetsu();
    } else {
      this.form.nengetsu = this.$route.params.nengetsu;
    }
    this.getData();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.tableHeight = window.innerHeight - 210;
      this.tableHeight = document.documentElement.clientHeight - 210;
    },
    getData() {
      this.loading = true;
      this.$axios.get('/gwr/gyomu/jokyoShokai/' + this.form.nengetsu)
          .then((response) => {
            response.data.forEach(shain => {
              shain.romuCheck1Flag = shain.romuCheck1Flag ? "ﾁｪｯｸ済" : "";
              shain.romuCheck2Flag = shain.romuCheck2Flag ? "ﾁｪｯｸ済" : "";
              shain.romuCheck3Flag = shain.romuCheck3Flag ? "ﾁｪｯｸ済" : "";
            });
            this.form.shainList = response.data;
            this.loading = false;
            this.handleResize();
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    showShainDialog(row) {
      this.shain = row;
      if (this.canHenshu) {
        this.shainDialogVisible = true;
      } else {
        this.shainJochoDialogVisible = true;
      }
    },
    showKyujitsuDialog() {
      this.kyujitsuDialogVisible = true;
    },
    gyomuHokoku(row) {
      this.loading = true;
      if (row.shainKubun == '1') {
        this.$parent.switchMenu('GyomuHokoku', '/gyomu', { nengetsu: this.form.nengetsu, shainId: row.shainId });
      } else if (row.shainKubun == '3' || row.shainKubun == '4' || row.shainKubun == '5' || row.shainKubun == '6') {
        this.$parent.switchMenu('GyomuHokokuK', '/gyomuK', { nengetsu: this.form.nengetsu, shainId: row.shainId });
      } else {
        notifyError(this, null, '予期せぬエラー', '社員区分の値が無効です。');
      }
    },
    isSelectable(row) {
      return (row.nyuryokuNissu != null && row.nyuryokuNissu > 0);
    },
    canSettei(row) {
      const loginUserId = this.$parent.getShainId();
      return (row.shainKubun == '3' || row.shainKubun == '4')
          || (row.eigyoShainId != loginUserId && row.eigyoShainId2 != loginUserId && row.eigyoShainId3 != loginUserId);
    },
    doFilter(row) {
      if (this.showOnlySelected) {
        if (this.showOnlyWorker) {
          return (row.taishokuBi == null) && this.isSelectable(row);
        }
        return this.isSelectable(row);
      } else {
        if (this.showOnlyWorker) {
          return (row.taishokuBi == null);
        }
        return true;
      }
    },
    changeSelect() {
      this.$refs.jokyoShokaiTable.clearSelection();
      this.form.shainList.forEach(row => {
        if (this.doFilter(row)
            && (row.jokyoKubun == this.jokyoSelect || 'All' == this.jokyoSelect || null == this.jokyoSelect)
            && (row.checkKekka == this.checkSelect || 'All' == this.checkSelect || null == this.checkSelect)
            && ((row.shainKubun == '1' && 'S' == this.shainSelect) || (row.shainKubun != '1' && 'O' == this.shainSelect) || 'All' == this.shainSelect || null == this.shainSelect)) {
          this.$refs.jokyoShokaiTable.toggleRowSelection(row);
        }
      });
    },
    selectTable() {
      this.jokyoSelect = null;
      this.checkSelect = null;
      this.shainSelect = null;
    },
    onChange(offset) {
      if (offset !== undefined) {
        this.form.nengetsu = this.$moment(this.form.nengetsu).add(offset, 'M').format('YYYY-MM');
      }
      this.$parent.setNengetsu(this.form.nengetsu);
      this.getData();
    },
    onDownload(shori, meisho, limit) {
      let shainIdList = [];
      let count = 0;
      this.$refs.jokyoShokaiTable.selection.forEach(shain => {
        if (count < limit) {
          shainIdList.push(shain.shainId);
        }
        count++;
      });
      if (shainIdList.length == 0) {
        notifyWarning(this, '選択', '出力対象の社員を選択してください。');
        return;
      }
      let msg = '選択された社員の' + meisho + 'を出力します。';
      if (shainIdList.length < count) {
        msg = '負荷低減のため、選択された最初の ' + limit + ' 件のみ出力します。';
      }
      this.$confirm(msg, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.loading = true;
        let params = new URLSearchParams();
        params.append('nengetsu', this.form.nengetsu);
        params.append('shainIdList', shainIdList);

        this.$axios.post('/gwr/gyomu/' + shori, params, { responseType: 'blob' })
          .then((response) => {
            downloadFile(this, response);
            this.getData();
          })
          .catch((error) => {
            notifyError(this, error, 'ダウンロードエラー');
          });
      });
    },
    onShonin() {
      this.changeJokyo("ikkatsuShonin", "21", "上長承認待ち", "承認");
    },
    onKakutei() {
      this.changeJokyo("ikkatsuKakutei", "52", "労務確認中", "確定");
    },
    onKaijo() {
      this.changeJokyo("ikkatsuKaijo", "53,54", "労務確認済み、労務処理済み", "解除");
    },
    changeJokyo(url, taishoKubun, taishoKubunMei, shoriMei) {
      let shainIdList = [];
      let loginUserId = this.$parent.getShainId();
      let isNotTaishoKubun = false;
      let hasMyGyomuhokoku = false;
      let isNotJocho = false;
      this.$refs.jokyoShokaiTable.selection.forEach(shain => {
        if (taishoKubun.indexOf(shain.jokyoKubun) == -1) {
          isNotTaishoKubun = true;
        }
        if (shain.shainId == this.$parent.getShainId()) {
          hasMyGyomuhokoku = true;
        }
        if (taishoKubun == '21' && shain.jochoShainId != loginUserId && shain.jochoShainId2 != loginUserId && shain.jochoShainId3 != loginUserId) {
          isNotJocho = true;
        }
        shainIdList.push(shain.shainId);
      });
      if (shainIdList.length == 0) {
        notifyWarning(this, '選択', shoriMei + '対象の社員を選択してください。');
        return;
      }
      else if (isNotTaishoKubun) {
        notifyWarning(this, 'エラー', '「' + taishoKubunMei + '」以外は' + shoriMei + 'できません。');
        return;
      }
      else if (hasMyGyomuhokoku && taishoKubun == '21') {
        notifyWarning(this, 'エラー', '自分自身の業務報告は' + shoriMei + 'できません。');
        return;
      }
      else if (isNotJocho) {
        notifyWarning(this, 'エラー', '上長に設定されている社員以外の業務報告は' + shoriMei + 'できません。');
        return;
      }

      this.$confirm(shainIdList.length + '名分の業務報告を' + shoriMei + 'します。よろしいですか？', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info'
      }).then(() => {
        this.loading = true;
        let params = new URLSearchParams();
        params.append('nengetsu', this.form.nengetsu);
        params.append('shainIdList', shainIdList);

        this.$axios.post('/gwr/wf/' + url, params)
            .then(() => {
              notifySuccess(this, '処理完了', shoriMei + 'しました。');
              this.getData();
            })
            .catch((error) => {
              notifyError(this, error, 'データ登録エラー');
            });
      });
    },
    onCloseShainDialog() {
      this.shainDialogVisible = false;
      this.getData();
    },
    onCloseShainJochoDialog() {
      this.shainJochoDialogVisible = false;
      this.getData();
    },
  },
}
</script>

<style scoped>
#formArea {
  width: 1360px;
  margin-left: auto;
  margin-right: auto;
  line-height: 35px;
}
.selectButtonsSize {
  width: 1398px;
}
.selectButtonsSizeRomu {
  width: 1590px;
}
#selectButtons {
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  text-align: left;
  border-top: 1px solid rosybrown;
}
.selecterLabel {
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
}
.jokyoShokaiTableSize {
  width: 1398px;
}
.jokyoShokaiTableSizeRomu {
  width: 1590px;
}
#jokyoShokaiTable {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  font-size:14px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> th {
  padding: 0px 0px;
  background-color: whitesmoke;
  border-color: lightgray;
  color: dimgray;
}
#jokyoShokaiTable >>> th div {
  padding: 0px 0px;
  text-align: center;
}
#jokyoShokaiTable >>> td {
  padding: 0px 0px;
  border-color: lightgray;
}
#jokyoShokaiTable >>> .el-button--mini {
  padding: 6px 10px;
}
.el-button {
  margin: 0px 1px !important;
}
.nengetsu {
  width: 140px;
  margin-bottom: 10px;
}
.comment-tooltip {
  white-space: pre;
  font-size: 14px;
}
</style>
